import React, { useEffect, useState } from 'react'
import AnalyticsCard from '../../../../../components/ClientDashboard/analytics-components/Shared/AnalyticsCard'
import DropoffKeywordInsights from '../../../../../components/ClientDashboard/analytics-components/ConversationAnalysis/DropoffKeywordInsights'
import MostRepeatedUserQueries from '../../../../../components/ClientDashboard/analytics-components/ConversationAnalysis/MostRepeatedUserQueries'
import UserAcquisitionRetentionTrends from '../../../../../components/ClientDashboard/analytics-components/ConversationAnalysis/UserAcquisitionRetentionTrends'

function ConversationAnalysisAnalyticsIndex({ dateFilterValue }) {
    return (
        <div> <AnalyticsCard
            redirection="/analytics/drop-off-keyword-insights/details"
            title="Drop-off Keyword Insights"
            dateFilterValue={dateFilterValue}
        >
            <DropoffKeywordInsights dateFilterValue={dateFilterValue} />
        </AnalyticsCard>

            <AnalyticsCard
                redirection="/analytics/most-repeated-user-queries/details"
                dateFilterValue={dateFilterValue}
            >
                <MostRepeatedUserQueries dateFilterValue={dateFilterValue} />
            </AnalyticsCard>

            <AnalyticsCard
                redirection="/analytics/user-acquisition-retention-trends/details"
                dateFilterValue={dateFilterValue}
            >
                <UserAcquisitionRetentionTrends dateFilterValue={dateFilterValue} />
            </AnalyticsCard>
        </div>
    )
}

export default ConversationAnalysisAnalyticsIndex

